(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5379:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8457);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2983);
/* harmony import */ var _better_bit_fe_base_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6640);
/* harmony import */ var _hooks_useFrame__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9146);
/* harmony import */ var _better_bit_fe_base_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7665);
/* harmony import */ var _components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5576);
// @ts-nocheck






function Page() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const curLang = (0,_better_bit_fe_base_utils__WEBPACK_IMPORTED_MODULE_4__/* .getLang */ .VQ)();
        // 保证其他页面也一致
        localStorage.setItem("LANG_KEY", curLang);
    }, []);
    (0,_hooks_useFrame__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "page-wrapper",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .HomeBanner */ .FS, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .Announcement */ .I7, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .HomeData */ .NE, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .PerpetualFutures */ .hO, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .Advantage */ .IN, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .Security */ .cU, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .Roadmap */ .wG, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .Partner */ .kT, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .Footer */ .$_, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HomePage_index__WEBPACK_IMPORTED_MODULE_5__/* .HoverComp */ .Gg, {})
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_better_bit_fe_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .withLayout */ .XC)(Page));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [550,162,365,887,576,774,888,179], function() { return __webpack_exec__(5379); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);